/**
 * Wspólny panel „Studio" (decyzja z TRE-1975/TRE-1983: scalony panel Ads Studio + Content
 * Studio, rozdzielone wdrożenia). Flaga obejmuje cały moduł; pierwszym wdrożonym elementem
 * jest Klipownia (produkcja klipów wideo), kreacje reklamowe z TRE-1658 dojdą obok.
 */
export const ADS_STUDIO_FEATURE_FLAG = "ads_studio_feature";
